{
	"title": "Ensuring accountability by installing a carbon bank",
	"description": "Heidelberg Materials has taken thorough measures to guarantee the credibility of carbon reductions generated by our CCS cement plant. To prevent any possibility of double accounting, we have implemented a secure virtual carbon bank on a public distributed ledger.",
	"traceabilityTitle": "Traceability of carbon reductions"
}
